import type {PageRouteConfig} from '@router';

import Splash from 'modules/Splash/Splash';

export function createUtmAsanaRoute(): PageRouteConfig {
  return {
    element: <Splash />,
    layout: {
      title: '',
      hasNavigate: false,
      hasHeader: false,
      hasBack: false,
      hasLeftIcon: false
    }
  };
}
